import request from '../utils/request'
import QS from "qs";

export function articleList (data) {
  return request({
    url: '/api/article',
    method: 'get',
    params:data,
  })
}
export function articleDes (id) {
  return request({
    url: `/api/article/${id}`,
    method: 'get'
  })
}
// /api/botchat
export function botChat (data) {
  return request({
    url: '/api/botchat',
    method: 'get',
    params:data,
  })
}
export function languageList () {
  return request({
    url: 'api/translate/language',
    method: 'get'
  })
}
/// /api/translate
export function translateSubmit (data) { // 翻译
  return request({
    url: 'api/translate',
    method: 'post',
    data:QS.stringify(data),
  })
}
